import { UniDriver } from '@wix/unidriver-core';
import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { baseUniDriverFactory } from '../../../utils/test-utils/unidriver';

export interface CardSubheaderUniDriver extends BaseUniDriver {
  title(): Promise<string>;
  titleNode(): UniDriver;
  suffixNode(): UniDriver;
}

export const cardSubheaderDriverFactory = (
  base: UniDriver,
): CardSubheaderUniDriver => {
  return {
    ...baseUniDriverFactory(base),
    /** Returns title text. */
    title: () => base.$('[data-hook="title"]').text(),
    /** Returns title node. */
    titleNode: () => base.$('[data-hook="title-node"] > *'),
    /** Returns suffix node. */
    suffixNode: () => base.$(`[data-hook="suffix-node"] > *`),
  };
};
